import { ROUTES } from "@/shared/config/routes";
import { useClientRedirect } from "@/shared/lib/router/redirect";

export default function AdminWebQaRedirect() {
  useClientRedirect(ROUTES.deliveryArea("web", "testes"));
  return null;
}

